import React, { ErrorInfo } from "react";
import JSErrorPage from "../features/jserrorpage/JSErrorPage";

type Props = {
  fallback?: React.FC;
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (process.env.NODE_ENV !== "production") {
      //TODO: Interface with error logging service
      console.error("Uncaught error:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      //   return this.props.fallback;
      return <JSErrorPage />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
